import { render, staticRenderFns } from "./FormWarehouse.vue?vue&type=template&id=47ca0e04&scoped=true&"
import script from "./FormWarehouse.vue?vue&type=script&lang=js&"
export * from "./FormWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./FormWarehouse.vue?vue&type=style&index=0&id=47ca0e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca0e04",
  null
  
)

export default component.exports